import { CategoryView } from '../../../types/entity-types';
import { hasVendorTransactionsInTimeframe } from './has-vendor-transactions-in-timeframe';

type GetCategoriesWithTransactionsInTimeframeArgs = {
  categories: CategoryView[];
  startDate: Date;
  endDate: Date;
};

export const getCategoriesWithTransactionsInTimeframe = ({
  categories,
  startDate,
  endDate,
}: GetCategoriesWithTransactionsInTimeframeArgs) => {
  return categories.filter((category) =>
    category.vendors?.some((v) => hasVendorTransactionsInTimeframe({ vendor: v, startDate, endDate })),
  );
};
